import { AxiosResponse } from 'axios';
import { orderList } from '@/api/order';
import { AppError } from '@/errors/appError';
import { baseListService, isRequestCanceled } from '@/services/baseService';
import { IListParams, IOrderApiListResponse, IOrderFilters } from '@/types';

export const orderService = {
    async list(params: IListParams<IOrderFilters>): Promise<AxiosResponse<IOrderApiListResponse>> {
        try {
            const response = await baseListService<IOrderApiListResponse>(orderList, params);
            return response;
        } catch (e) {
            if (isRequestCanceled(e)) throw e;
            console.error('Order API Error:', e);
            throw new AppError(`Unable to load order list, request error`, { cause: e });
        } finally {
        }
    },
};
